export default "__VITE_ASSET__ad7ab77e__"